// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import { Provider, themes } from '@fluentui/react-northstar' //https://fluentsite.z22.web.core.windows.net/quick-start
import { initializeIcons } from '@fluentui/font-icons-mdl2';

initializeIcons();

ReactDOM.render(
    <Provider>
        <App />
    </Provider>, document.getElementById('root')
);
